module.exports = __webpack_public_path__ + "static/img/product09-2.f4d8a7ed.png";